/* eslint-disable */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiViewDashboard,
  mdiAccountAlert,
  mdiBusDoubleDecker,
  mdiAccountArrowLeft,
  mdiAccountArrowLeftOutline,
  mdiFaceAgent,
  mdiTextBoxMultipleOutline,
  mdiCashMultiple,
} from "@mdi/js";
export default [
  {
    to: "/comboard-dashboard",
    icon: mdiViewDashboard,
    label: "sidebar.dashboard",
  },
  {
    label: "sidebarFin.transaction",
    // label: "Transaction",
    subLabel: "Submenus Transaction",
    icon: mdiCashMultiple,
    menu: [
      {
        to: "/invoicetransaction-parent",
        label: "sidebarFin.invoicetransaction",
        // label: "sidebarFin.invoicetransaction",
        icon: mdiTextBoxMultipleOutline,
      },
      {
        to: "/paymenttransaction-parent",
        label: "sidebarFin.paymenttransaction",
        // label: "sidebarFin.paymenttransaction",
        icon: mdiTextBoxMultipleOutline,
      },
    ],
  },
  {
    label: "sidebarFin.permissionRequest",
    // label: "Permission Request",
    subLabel: "Submenus Teacher",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/permissions-parent",
        label: "sidebarFin.permissions",
        // label: "Permissions",
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "sidebarFin.attendance",
    // label: "Attendance",
    subLabel: "Submenus Attendance",
    icon: mdiAccountArrowLeft,
    menu: [
      {
        to: "/regular-subject-parent",
        label: "sidebarFin.regularSubject",
        // label: "Regular Subject",
        icon: mdiAccountArrowLeftOutline,
      },
      // {
      //   to: "/attendance-streaming-parent",
      //   label: "Streaming Subject",
      //   icon: mdiAccountArrowLeftOutline,
      // },
      {
        to: "/report-attendance-daily-parent",
        label: "sidebarFin.dailyAttendanceReport",
        // label: "Daily Attendance Report",
        icon: mdiAccountAlert,
      },
      {
        to: "/assignment-special",
        label: "sidebarFin.specialAssignment",
        // label: 'Special Assignment',
        icon: mdiBusDoubleDecker,
      },
    ],
  },
];
